import { useContext} from "react";
import { ThemeContext } from "../../context/ThemeContext";

function CardCentered(props){
    const theme = useContext(ThemeContext);
    const {dark} = theme;
    return <div className={`relative mx-auto p-8 ${dark ? "bg-neutral-900" : "bg-white"} rounded-lg w-3/4 mb-10 justify-center items-center shadow-md`}>{props.children}</div>
}

export default CardCentered;